import {combineReducers} from "redux";
import {userReducer} from "./userReducer";
import {appReducer} from "./appReducer";
import {tableReducer} from "./tableReducer";
import {gameReducer} from "./gamesReducer";

export const mainReducer = combineReducers({
    user: userReducer,
    app: appReducer,
    game: gameReducer,
    table: tableReducer
})